import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  SetOptions,
  SetTheme,
  SetActiveTheme,
} from '../actions/options.actions';

export interface OptionsStateModel {
  theme: string;
  activeTheme: string;
}

const defaults: OptionsStateModel = {
  theme: 'light',
  activeTheme: 'purple_theme',
};

@State<OptionsStateModel>({
  name: 'options',
  defaults,
})
@Injectable()
export class OptionsState {
  @Selector()
  static options(state: OptionsStateModel): OptionsStateModel {
    return state;
  }

  @Selector()
  static theme(state: OptionsStateModel): string {
    return state.theme;
  }

  @Selector()
  static activeTheme(state: OptionsStateModel): string {
    return state.activeTheme;
  }

  ngxsOnInit(ctx: StateContext<OptionsStateModel>) {
    const storedOptions = localStorage.getItem('optionsState');
    if (storedOptions) {
      try {
        const parsedOptions: OptionsStateModel = JSON.parse(storedOptions);
        ctx.patchState(parsedOptions);
      } catch {
        localStorage.removeItem('optionsState');
      }
    }
  }

  @Action([SetOptions, SetTheme, SetActiveTheme])
  persistState(ctx: StateContext<OptionsStateModel>, action: any) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      ...action.options,
      theme: action.theme ?? state.theme,
      activeTheme: action.activeTheme ?? state.activeTheme,
    });

    const updatedState = ctx.getState();
    localStorage.setItem('optionsState', JSON.stringify(updatedState));
  }
}
